'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Dependencies: jQuery, Waypoints, sticky.scss
// Class shouldn't be called outside of document.ready

var Sticky = function () {
	function Sticky(_ref) {
		var _this = this;

		var id = _ref.id,
		    _ref$offset = _ref.offset,
		    offset = _ref$offset === undefined ? 0 : _ref$offset,
		    stage = _ref.stage,
		    _ref$type = _ref.type,
		    type = _ref$type === undefined ? 'fixed' : _ref$type,
		    _ref$container = _ref.container,
		    container = _ref$container === undefined ? false : _ref$container,
		    _ref$parent = _ref.parent,
		    parent = _ref$parent === undefined ? false : _ref$parent;

		_classCallCheck(this, Sticky);

		this.insurance();

		$(window).on('load', function () {
			_this.selector = id;
			_this.$el = $('#' + id);
			_this.el = document.getElementById(_this.selector);
			_this.height = function () {
				return _this.$el.outerHeight();
			};
			_this.parent = parent;
			_this.offset = function () {
				return _this.parent ? _this.parent.height() : 0;
			};
			_this.stage = $(stage);
			_this.type = type;
			_this.container = container;
			_this.container_added = false;
			_this.waypoint_selector = _this.selector + '-waypoint';
			_this.create_ghost();

			// Browsers have a bug where they can't display a fixed child inside of a parent that is being transformed... which is what this becomes when the stage opens up. As such, we can use 'sticky' instead of fixed, but this doesn't work in any microsoft browsers. Ref: https://stackoverflow.com/questions/2637058/positions-fixed-doesnt-work-when-using-webkit-transform
			if (_this.type === 'sticky' && !_this.isMSI()) {
				_this.position = 'sticky';
				_this.$el.addClass('sticky-sticky');
			} else {
				_this.position = 'fixed';
				_this.$el.addClass('sticky-fixed');
			}

			if (_this.stage) _this.handle_mobile_stage();

			_this.set_waypoints(function (direction) {
				return _this.handle_waypoints(direction);
			});
			$(window).resize(function () {
				_this.height();

				_this.set_waypoints(function (direction) {
					return _this.handle_waypoints(direction);
				}, true);
			});
		});
	}

	_createClass(Sticky, [{
		key: 'insurance',
		value: function insurance() {
			// prevents waypoints from triggering while the page is being painted
			$('html, body').animate({
				scrollTop: 0
			}, 0);
		}
	}, {
		key: 'fixit',
		value: function fixit() {
			if (this.position === 'fixed') {
				this.ghost.css({
					height: this.height() - 1 // the difference of height of waypoints
				});
			}

			if (this.container && !this.container_added) {
				this.container_added = true;
				this.addContainer();
			}

			this.$el.addClass('sticky').css({
				top: this.offset()
			});

			if (this.parent) this.parent.$el.addClass('sticky-child-active');

			this.$el.trigger('sticky-set');
		}
	}, {
		key: 'unfixit',
		value: function unfixit() {
			this.ghost.css({
				height: 1
			});

			if (this.container && this.container_added) {
				this.container_added = false;
				this.removeContainer();
			}

			this.$el.css({
				top: 0
			}).removeClass('sticky');

			if (this.parent) this.parent.$el.removeClass('sticky-child-active');

			this.$el.trigger('sticky-unset');
		}
	}, {
		key: 'addContainer',
		value: function addContainer() {
			this.$el.html('\n\t\t<div class="container">\n\t\t\t' + this.$el.html() + '\n\t\t</div>\n\t');
		}
	}, {
		key: 'removeContainer',
		value: function removeContainer() {
			this.$el.html(this.$el.find('.container').html());
		}
	}, {
		key: 'create_ghost',
		value: function create_ghost() {
			$('<div id="' + this.selector + '-ghost"  style="height: 1px; width: 100%;"></div>').insertBefore(this.$el);
			this.ghost = $('#' + this.selector + '-ghost');
		}
	}, {
		key: 'handle_waypoints',
		value: function handle_waypoints(direction) {
			if (this.height() > 0) {
				direction === 'down' ? this.fixit() : this.unfixit();
			}
		}
	}, {
		key: 'set_waypoints',
		value: function set_waypoints(callback) {
			var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (reset && this.waypoint) {
				this.waypoint[0].destroy();
			} else {
				$('<div class="' + this.waypoint_selector + '"  style="width: 100%; height: 1px;"></div>').insertBefore(this.$el);
			}
			if (!this.$waypoint) this.$waypoint = $('.' + this.waypoint_selector);

			if (!this.$el.css('margin-top')) console.error('Wo! Looks like you\'re missing something. We couldn\'t find the margin property with on the el.');

			// if (this.$waypoint.length > 1) {
			if (this.$waypoint.length > 0) {
				this.waypoint = this.$waypoint.waypoint({
					handler: callback,
					offset: this.offset()
				});
			}
		}
	}, {
		key: 'handle_mobile_stage',
		value: function handle_mobile_stage() {
			this.stage.css({
				position: 'fixed',
				overflowY: 'scroll'
			});
		}
	}, {
		key: 'isMSI',
		value: function isMSI() {
			if (/MSIE 10/i.test(navigator.userAgent)) {
				// This is internet explorer 10
				return true;
			}

			if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
				// This is internet explorer 9 or 11
				return true;
			}

			if (/Edge\/\d./i.test(navigator.userAgent)) {
				// This is Microsoft Edge
				return true;
			}

			return false;
		}
	}]);

	return Sticky;
}();